export default {
    clientLoading: state => state.clientLoading,
    clientsListLoading: state => state.clientsListLoading,
    clientsList: state => state.clientsList,
    pdrListLoading: state => state.pdrListLoading,
    pdrLists: state => state.pdrLists,
    priceLists: state => state.priceLists
}